"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogService = void 0;
var http_client_1 = require("@wix/http-client");
var get_auth_header_1 = require("@wix/wix-vod-shared/dist/src/common/utils/get-auth-header");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var editor_type_1 = require("@wix/wix-vod-shared/dist/src/common/utils/editor-type");
var CatalogService = /** @class */ (function () {
    function CatalogService(baseUrlPath) {
        if (baseUrlPath === void 0) { baseUrlPath = ''; }
        var baseURL = (0, editor_type_1.isEditorX)()
            ? hosts_1.PRODUCTION_HOSTS.catalogEditorX
            : hosts_1.PRODUCTION_HOSTS.catalog;
        this.httpClient = new http_client_1.HttpClient({
            baseURL: baseURL + baseUrlPath,
            xsrfCookieName: 'non-existing-cookie',
            withCredentials: true,
            getAppToken: function () { return (0, get_auth_header_1.getAuthorizationToken)(); },
        });
    }
    return CatalogService;
}());
exports.CatalogService = CatalogService;
//# sourceMappingURL=catalog-service.js.map